import { Controller } from "@hotwired/stimulus";
import { Modal } from "bootstrap";

export default class extends Controller {
  static targets = ["modal", "form", "groupSelect", "nameInput"];
  static values = {
    baseUrl: String
  };

  connect() {
    this.handleModalHidden = this.handleModalHidden.bind(this);

    if (this.hasModalTarget) {
      this.modalTarget.addEventListener("hidden.bs.modal", this.handleModalHidden);
    }
  }

  disconnect() {
    if (this.hasModalTarget) {
      this.modalTarget.removeEventListener("hidden.bs.modal", this.handleModalHidden);
    }
  }

  open(event) {
    event.preventDefault();

    const { sessionId, groupId } = event.currentTarget.dataset;

    this.formTarget.action = this.baseUrlValue.replace(":id", sessionId);
    this.groupSelectTarget.value = groupId || "";
    this.nameInputTarget.value = "";

    Modal.getOrCreateInstance(this.modalTarget).show();
  }

  clearName() {
    this.nameInputTarget.value = "";
  }

  clearGroup() {
    this.groupSelectTarget.value = "";
  }

  handleModalHidden() {
    this.groupSelectTarget.value = "";
    this.nameInputTarget.value = "";
  }
}
